import { gql } from 'src/__generated__';

gql(`
  fragment JobFragment on Job {
    id
    createdAt {
      shortLabel
    }
    content
    title
    advertiser {
      id
      name(locale: $locale)
    }
    abstract
    source
    products {
      branding {
        id
        logo {
          url
        }
      }
      displayTags {
        label(locale: $locale)
      }
    }
    tracking {
      isPrivateAdvertiser
      hasRoleRequirements
    }
    location {
      label(locale: $locale, type: SHORT)
    }       
  }
`);

gql(`
  fragment LocationFragment on JobApplicationProcess {
    location {
      id
      name
    }
    state {
      id
    }
    area {
      id
      name
    }
  }
`);

gql(`
  fragment ClassificationFragment on JobApplicationProcess {
    classification {
      id
      name
      subClassification {
        id
        name
      }
    }
  }
`);

gql(`
  fragment DocumentsFragment on JobApplicationProcess {
    documents {
      lastAppliedResumeIdPrefill @include(if: $isAuthenticated)
      selectionCriteriaRequired
      lastWrittenCoverLetter @include(if: $isAuthenticated) {
        content
      }
    }
  }
`);

gql(`
  fragment QuestionnaireFragment on JobApplicationProcess {
    questionnaire {
      questions @include(if: $isAuthenticated) {
        id
        text
        __typename
        ... on SingleChoiceQuestion {
          lastAnswer {
            id
            text
            uri
          }
          options {
            id
            text
            uri
            __typename
          }
        }
        ... on MultipleChoiceQuestion {
          lastAnswers {
            id
            text
            uri
          }
          options {
            id
            text
            uri
            __typename
          }
        }
        ... on PrivacyPolicyQuestion {
          url
          options {
            id
            text
            uri
            __typename
          }
        }
      }
    }
  }
`);

gql(`	
	fragment RequiredVerificationsFragment on JobApplicationProcess {
		requiredVerifications(platform: $platform) {
      trackingCorrelationId
    	verifications {
        countryCode
        countryLabel(locale: $locale) {
          label
          locale
        }
        nudgeUrl
        __typename  
      } 
		}
  }
`);

export const GET_JOB_APPLICATION_PROCESS = gql(`
  query GetJobApplicationProcess(
    $jobId: ID!
    $isAuthenticated: Boolean!
    $locale: Locale!
    $platform: Platform
    $fetchRequiredVerifications: Boolean = false
  ) {
    jobApplicationProcess(jobId: $jobId) {
      ...LocationFragment
      ...ClassificationFragment
      ...DocumentsFragment
      ...QuestionnaireFragment
      ...RequiredVerificationsFragment @include(if: $fetchRequiredVerifications)
      job { 
        ...JobFragment 
      }
      linkOut
      extractedRoleTitles
    }
  }

`);

export const GET_JOB = gql(`
  query GetJobDetails($jobId: ID!, $locale: Locale!) {
    jobDetails(id: $jobId) {
      job {
        ...JobFragment
      }
    }
  }
`);
